import { render, staticRenderFns } from "./user_info.vue?vue&type=template&id=705fe1d1"
import script from "./user_info.vue?vue&type=script&lang=js"
export * from "./user_info.vue?vue&type=script&lang=js"
import style0 from "./user_info.vue?vue&type=style&index=0&id=705fe1d1&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports